import { Button, Card, Input, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { deleteRolePermission } from "./roleApis";

const CustomTable = ({ role, roleId }) => {
	const [keys, setKeys] = useState([]);
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const companyId = localStorage.getItem("company_id");
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

	console.log("roleId", roleId);

	const columns = [
		{
			id: 2,
			title: "Permission Name",
			dataIndex: "permission",
			key: "permission",
			render: ({ name } = {}) => name,
		},
		{
			id: 3,
			title: "Created At",
			dataIndex: "createdAt",
			key: "createdAt",
			render: (createdAt) => dayjs(createdAt).format("DD/MM/YYYY"),
		},
		{
			id: 4,
			title: "Updated At",
			dataIndex: "updatedAt",
			key: "updatedAt",
			render: (updatedAt) => dayjs(updatedAt).format("DD/MM/YYYY"),
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
		setFilteredData(addKeys(role));
	}, [role]);

	useEffect(() => {
		// Filter the data based on the search term
		const filtered = role.filter(({ permission: { name } = {} }) =>
			name.toLowerCase().includes(searchTerm.toLowerCase())
		);
		setFilteredData(addKeys(filtered));
	}, [searchTerm, role]);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			setKeys(selectedRowKeys);
		},
	};
	const [loader, setLoader] = useState(false);

	const onDelete = async () => {
		setLoader(true);
		try {
			const data = await deleteRolePermission(keys);
			if (data.message === "success") {
				window.location.reload();
				setLoader(false);
			}
		} catch (error) {
			setLoader(false);
			console.log(error.message);
		}
	};

	return (
		<Card className='card-body mb-3 '>
			<div className='table-responsive'>
				<h4 className='text-center mb-2 text-2xl'> Permissions</h4>


				{/* {keys && keys.length > 0 && companyId <= 1 &&(
					<div className='text-start mb-1'>
						<Button type='danger' onClick={onDelete} loading={loader}>
							Delete
						</Button>
					</div>
				)} */}
				{/* {console.log("kk",roleId)}; */}



				{/* {keys && keys.length > 0 && roleId >2 &&(
					<div className='text-start mb-1'>
						<Button type='danger' onClick={onDelete} loading={loader}>
							Remove Permission
						</Button>
					</div>
				)}
				{columns.length > 0 && (
					<div style={{ marginBottom: "30px" }}>
						<ColVisibilityDropdown
							options={columns}
							columns={columns}
							columnsToShowHandler={columnsToShowHandler}
						/>
					</div>
				)}
				<Input
					placeholder="Search by name"
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
					style={{ marginBottom: "15px", width: "200px" }}
				/> */}

				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "15px" }}>
					{/* Remove Permission Button */}
					{keys && keys.length > 0 && roleId > 2 && (
						<Button type="danger" onClick={onDelete} loading={loader} style={{ marginRight: "15px" }}>
							Remove Permission
						</Button>
					)}
					{/* Column Visibility Dropdown */}
					{columns.length > 0 && (
						<ColVisibilityDropdown
							options={columns}
							columns={columns}
							columnsToShowHandler={columnsToShowHandler}
							style={{ marginRight: "15px" }} // Optional: Add margin to space out elements
						/>
					)}
					{/* Search Input */}
					<Input
						placeholder="Search by permission name"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						style={{ width: "200px" }}
					/>
				</div>
				<Table
					rowSelection={columnsToShow.length > 0 && rowSelection}
					columns={columnsToShow}
					dataSource={filteredData}
					pagination={{
						pageSize: 20,
						showSizeChanger: true,
						pageSizeOptions: ["10", "20", "50"],
					}}
					rowKey={(record) => record.id}
				/>
				{/* <table className='table '>
					<thead className='thead-dark'>
						<tr>
							<th scope='col'>#ID</th>
							<th scope='col'>Permission Name</th>
							<th scope='col'>Created AT</th>
							<th scope='col'>Updated AT</th>
						</tr>
					</thead>
					<tbody>
						{role &&
							role.map((i) => (
								<tr>
									<th scope='row'>{i.id}</th>
									<td>{i.permission.name}</td>
									<td>{dayjs(i.createdAt).format("YYYY-MM-DD")}</td>
									<td>{dayjs(i.updatedAt).format("YYYY-MM-DD")}</td>
								</tr>
							))}
					</tbody>
				</table> */}
			</div>
		</Card>
	);
};

export default CustomTable;
